(function () {
  var cfg = window.MystikCartConfig || {};
  var moneyFormat = cfg.moneyFormat || '\u20AC{{amount_with_comma_separator}}';
  var shopEnabled = cfg.shopEnabled !== false;
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function delim(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return d + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(placeholderRegex); var value;
    switch (m && m[1]) {
      case 'amount_no_decimals': value = delim(cents, 0); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      default: value = delim(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }
  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ================= MOTION-ENGINE ================= */
  var MO = window.MystikMotion || {};
  var prefersReduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var forced = MO.force === true;
  // Systemwunsch "Bewegung reduzieren" schaltet nur die kräftigen Effekte ab —
  // ein sanftes Fade-in bleibt erhalten (es sei denn, es wird komplett deaktiviert).
  var softMode = prefersReduce && !forced;
  var reduced = MO.designMode === true
    || document.documentElement.classList.contains('mk-no-motion')
    || (document.body && document.body.classList.contains('mk-no-motion'))
    || MO.reveal === false;
  if (softMode) document.documentElement.classList.add('mk-soft');

  function assignStagger(els) {
    var groups = {};
    els.forEach(function (el) {
      if (el.dataset.mkDelay) return;
      var sec = el.closest('[id^="shopify-section-"]') || document.body;
      var key = sec.id || 'body';
      groups[key] = groups[key] || [];
      groups[key].push(el);
    });
    var step = MO.stagger || 145;
    Object.keys(groups).forEach(function (k) {
      groups[k].forEach(function (el, i) { el.dataset.mkDelay = String(Math.min(i * step, 720)); });
    });
  }

  var pending = [];

  function initReveal() {
    if (reduced) {
      qa('.mk-reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
      pending = [];
      return;
    }
    var fresh = qa('.mk-reveal:not([data-mk-revealed])');
    if (!fresh.length) return;
    assignStagger(fresh);
    fresh.forEach(function (el) {
      el.setAttribute('data-mk-revealed', '1');
      pending.push(el);
    });
    checkPending();
    armSafetyNet();
  }

  // Positionsprüfung statt IntersectionObserver: funktioniert auch in Iframes
  // (Shopify-Theme-Editor, In-App-Browser) und in älteren WebViews.
  function checkPending() {
    if (!pending.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight || 800;
    var trigger = vh * 0.94;
    var still = [];
    for (var i = 0; i < pending.length; i++) {
      var el = pending[i];
      var r = el.getBoundingClientRect();
      if (r.top < trigger && r.bottom > -60) show(el); else still.push(el);
    }
    pending = still;
  }

  function show(el) {
    var delay = parseInt(el.dataset.mkDelay || '0', 10);
    if (delay > 0) setTimeout(function () { el.classList.add('is-in'); }, delay);
    else el.classList.add('is-in');
  }

  // Sicherheitsnetz: Inhalte bleiben unter keinen Umständen unsichtbar.
  var safetyTimer = null;
  function armSafetyNet() {
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(function () {
      // Nur Elemente im (erweiterten) Viewport zwangs-einblenden — Inhalte weiter
      // unten behalten ihren Reveal und animieren, sobald sie erscrollt werden.
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      qa('.mk-reveal:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh + 80 && r.bottom > -80) el.classList.add('is-in');
      });
    }, 2500);
  }

  /* ---------- Zahlen zählen hoch ---------- */
  var pendingNums = [];
  function initCounters() {
    if (reduced || softMode || MO.counters === false) return;
    qa('.mk-num:not([data-mk-counted])').forEach(function (el) {
      el.setAttribute('data-mk-counted', '1');
      var m = el.textContent.match(/(\d+(?:[.,]\d+)?)/);
      if (m) pendingNums.push(el);
    });
    checkNums();
  }
  function checkNums() {
    if (!pendingNums.length) return;
    var vh = window.innerHeight || 800;
    var still = [];
    pendingNums.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.85 && r.bottom > 0) runCount(el); else still.push(el);
    });
    pendingNums = still;
  }
  function runCount(el) {
    var raw = el.textContent;
    var m = raw.match(/(\d+(?:[.,]\d+)?)/);
    if (!m) return;
    var target = parseFloat(m[1].replace(',', '.'));
    var decimals = (m[1].split(/[.,]/)[1] || '').length;
    var sep = m[1].indexOf(',') > -1 ? ',' : '.';
    var before = raw.slice(0, m.index);
    var after = raw.slice(m.index + m[1].length);
    var start = null;
    function fmt(v) { var s = v.toFixed(decimals); return decimals ? s.replace('.', sep) : s; }
    function step(now) {
      if (start === null) start = now;
      var p = Math.min((now - start) / 1100, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = before + fmt(target * eased) + after;
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    el.textContent = before + fmt(0) + after;
    requestAnimationFrame(step);
  }

  /* ---------- Parallax ---------- */
  var parallaxEls = [];
  function initParallax() {
    if (reduced || softMode || MO.parallax === false) return;
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) { parallaxEls = []; return; }
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches && window.innerWidth < 1024) { parallaxEls = []; return; }
    parallaxEls = qa('.mk-parallax');
    if (!parallaxEls.length) return;
    onScroll();
  }
  function runParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var mid = r.top + r.height / 2;
      var offset = ((mid - vh / 2) / vh) * -1 * (parseFloat(el.dataset.mkDepth) || 16);
      el.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
    });
  }

  /* ---------- Scroll-Progress + Header-Shrink ---------- */
  var progressEl = null, ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (progressEl) {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        progressEl.style.width = (h > 0 ? Math.min(y / h, 1) * 100 : 0) + '%';
      }
      if (MO.shrink !== false) document.body.classList.toggle('mk-scrolled', y > 60);
      checkPending();
      checkNums();
      if (pending.length) armSafetyNet();
      if (parallaxEls.length) runParallax();
    });
  }

  /* ---------- Accordion: nativ + CSS-Animation (kein JS-Höhen-Handling) ---------- */
  function initAccordions() {
    qa('details.mk-acc:not([data-mk-acc])').forEach(function (d) { d.setAttribute('data-mk-acc', '1'); });
  }

  window.addEventListener('error', function () {
    // Falls irgendwo ein Fehler auftritt: Inhalte niemals unsichtbar lassen
    qa('.mk-reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
  });

  // Bleibt der Shopify-Forms-Block leer (Formular nicht veröffentlicht oder nicht gewählt),
  // erscheint automatisch das Standardformular — die Seite bleibt nie ohne Formular.
  // Erkennt, ob im App-Block tatsächlich ein Formular steckt.
  // Shopify Forms rendert häufig in Custom Elements / Shadow-DOM — dort findet
  // querySelector() keine input-Felder. Deshalb mehrere Nachweise prüfen.
  function formAppHasContent(wrap) {
    if (wrap.querySelector('form, iframe, input, textarea, button, select, [class*="shopify-forms"], [class*="form"]')) return true;
    var els = wrap.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) return true;
      if (els[i].tagName && els[i].tagName.indexOf('-') > -1) return true;
    }
    return wrap.scrollHeight > 140;
  }

  // Zeigt automatisch das native Theme-Formular, wenn das App-Widget leer bleibt,
  // in einem iframe liegt oder die Theme-Schrift dort nachweislich nicht greift.
  function initFormFallback() {
    var themeFont = (getComputedStyle(document.body).fontFamily || 'Jost').split(',')[0].replace(/["']/g, '').trim();
    qa('[data-mk-formapp]').forEach(function (wrap) {
      var scope = wrap.closest('.mk-cform, section') || document;
      var std = scope.querySelector('[data-mk-stdform]');
      if (!std) return;
      function takeover() { std.removeAttribute('hidden'); wrap.setAttribute('hidden', ''); }
      var tries = 0;
      (function check() {
        tries++;
        var probe = null, sawIframe = false;
        var queue = [wrap];
        while (queue.length && !probe) {
          var els = queue.shift().querySelectorAll('*');
          for (var i = 0; i < els.length; i++) {
            var el = els[i];
            if (el.shadowRoot) queue.push(el.shadowRoot);
            var t = el.tagName;
            if (t === 'IFRAME') sawIframe = true;
            if (t === 'BUTTON' || t === 'INPUT' || t === 'SELECT' || t === 'TEXTAREA' || t === 'LABEL') { probe = el; break; }
          }
        }
        if (probe) {
          var fam = getComputedStyle(probe).fontFamily || '';
          if (fam.indexOf(themeFont) !== -1) return; /* Theme-Schrift greift — Widget bleibt */
          if (tries >= 10) { takeover(); return; }   /* erreichbar, aber Schrift greift nicht */
        } else if (sawIframe && tries >= 6) { takeover(); return; } /* iframe: von außen unerreichbar */
        else if (tries >= 14) { takeover(); return; }               /* nichts Style-bares gefunden */
        setTimeout(check, 450);
      })();
    });
  }

  // Shopify Forms kann Teile im Shadow-DOM rendern — dort greift externes CSS nicht.
  var mkShadowStyle = '*{font-family:var(--font-body,Jost,sans-serif)!important;box-sizing:border-box!important}'
    + 'label,legend{display:block;font-size:11px!important;font-weight:600!important;letter-spacing:.22em!important;text-transform:uppercase!important;color:#7D5F31!important;margin-bottom:8px!important}'
    + 'input[type=text],input[type=email],input[type=tel],textarea,select{width:100%!important;padding:21px 15px 7px!important;min-height:54px!important;height:auto!important;border:1px solid rgba(26,31,43,.18)!important;border-radius:var(--mk-radius,2px)!important;background:#FAF9F5!important;font-size:15px!important;font-weight:300!important;line-height:1.5!important;color:#1A1F2B!important;outline:none!important}'
    + 'input:focus,textarea:focus,select:focus{border-color:#B08C4F!important;background:#fff!important}'
    + 'textarea{padding-top:24px!important;padding-bottom:12px!important;min-height:132px!important;resize:vertical!important;line-height:1.7!important}'
    + 'input[type=file]{width:100%!important;padding:16px!important;border:1px dashed rgba(176,140,79,.65)!important;border-radius:var(--mk-radius,2px)!important;background:rgba(176,140,79,.05)!important;font-size:14px!important;font-weight:300!important;cursor:pointer}'
    + 'input[type=file]::file-selector-button{font-size:11.5px!important;font-weight:600!important;letter-spacing:.14em!important;text-transform:uppercase!important;margin-right:16px!important;padding:11px 18px!important;border:1px solid rgba(26,31,43,.3)!important;border-radius:var(--mk-radius,2px)!important;background:#fff!important;color:#1A1F2B!important;cursor:pointer}'
    + 'input[type=checkbox],input[type=radio]{width:16px!important;height:16px!important;accent-color:#7D5F31!important;margin-top:3px!important;flex:0 0 auto!important}'
    + 'button[type=submit],input[type=submit]{width:100%!important;cursor:pointer;border:none!important;border-radius:var(--mk-radius,2px)!important;background:linear-gradient(135deg,#DCC28C,#B08C4F 55%,#9A7A42)!important;color:#14181F!important;font-size:13px!important;font-weight:600!important;letter-spacing:.14em!important;text-transform:uppercase!important;padding:18px 34px!important;margin-top:10px!important}'
    + 'button:not([type=submit]){width:100%!important;min-width:0!important;display:inline-flex!important;align-items:center!important;justify-content:space-between!important;text-align:left!important;gap:10px!important;min-height:54px!important;background:#FAF9F5!important;background-image:none!important;color:#1A1F2B!important;border:1px solid rgba(26,31,43,.18)!important;border-radius:var(--mk-radius,2px)!important;box-shadow:none!important;padding:13px 16px!important;margin-top:0!important;font-size:15px!important;font-weight:300!important;letter-spacing:0!important;text-transform:none!important;cursor:pointer}'
    + '[class*=phone]>button,[class*=tel]>button{width:auto!important;flex:0 0 auto!important;justify-content:center!important;padding:13px 14px!important}'
    + '*{max-width:100%!important}'
    + '[class*=phone],[class*=tel]{display:flex!important;align-items:stretch!important;gap:10px!important}'
    + '[class*=phone] input,[class*=tel] input{flex:1 1 auto!important;width:auto!important;min-width:0!important}'
    + '[role=listbox],[role=menu]{background:#fff!important;border:1px solid rgba(26,31,43,.14)!important;border-radius:var(--mk-radius,2px)!important;box-shadow:0 18px 40px rgba(26,31,43,.14)!important}'
    + '[role=option],[role=menuitem]{background:transparent!important;color:#1A1F2B!important;font-size:14.5px!important;font-weight:300!important;letter-spacing:0!important;text-transform:none!important;padding:11px 14px!important}'
    + 'h1,h2,h3,h4{font-family:var(--font-head,Marcellus,serif)!important;font-weight:400!important;color:#1A1F2B!important}'
    + 'a{color:#7D5F31!important}'
    + ':host,*{--color-primary:#7D5F31;--primary-color:#7D5F31;--accent-color:#7D5F31;--focus-color:#B08C4F;accent-color:#7D5F31}'
    + '*:focus,*:focus-visible{outline-color:#B08C4F!important}'
    + 'input:focus,textarea:focus,select:focus,button:focus{border-color:#B08C4F!important;box-shadow:0 0 0 3px rgba(176,140,79,.18)!important;outline:none!important}'
    + 'svg{color:#7D5F31!important}';

  // Innere Shadow-Ebenen: NUR Typografie — Dekor bleibt der App überlassen
  var mkShadowStyleLite = '*{font-family:var(--font-body,Jost,sans-serif)!important}'
    + 'h1,h2,h3,h4,h5{font-family:var(--font-head,Marcellus,serif)!important;font-weight:400!important}';

  function styleFormApp() {
    var hosts = qa('[data-mk-formapp].mk-formapp--themed');
    if (!hosts.length) return;
    var tries = 0;
    function inject(root, css) {
      var st = root.querySelector('[data-mk-shadow-style]');
      if (st) { if (st.textContent !== css) st.textContent = css; return; }
      st = document.createElement('style');
      st.setAttribute('data-mk-shadow-style', '1');
      st.textContent = css;
      root.appendChild(st);
    }
    (function walk() {
      hosts.forEach(function (host) {
        var queue = [{ scope: host, depth: 0 }];
        while (queue.length) {
          var item = queue.shift();
          var els = item.scope.querySelectorAll('*');
          for (var i = 0; i < els.length; i++) {
            if (!els[i].shadowRoot) continue;
            inject(els[i].shadowRoot, item.depth === 0 ? mkShadowStyle : mkShadowStyleLite);
            queue.push({ scope: els[i].shadowRoot, depth: item.depth + 1 });
          }
        }
      });
      if (++tries < 40) setTimeout(walk, 400);
    })();
  }

  function initMotion() {
    progressEl = q('[data-mk-progress]');
    initReveal();
    initCounters();
    initAccordions();
    initFormFallback();
    styleFormApp();
    initParallax();
    onScroll();
  }
  // Nach der Transition GPU-Hinweis entfernen → weniger Speicher, flüssigeres Scrollen
  document.addEventListener('transitionend', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('is-in') && el.classList.contains('mk-reveal')) {
      el.style.willChange = 'auto';
    }
  }, true);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ================= Cookie-Einstellungen ================= */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mk-cookie-prefs]')) return;
    e.preventDefault();
    try {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return; }
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') { window.Shopify.customerPrivacy.showPreferences(); return; }
    } catch (err) {}
    var banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
    if (banner) { banner.style.display = ''; banner.removeAttribute('hidden'); }
  });

  /* ================= Filter-Chips (Galerie) ================= */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-mk-gal-filter]');
    if (!chip) return;
    var target = chip.dataset.mkGalTarget;
    qa('[data-mk-gal-filter][data-mk-gal-target="' + target + '"]').forEach(function (c) { c.classList.remove('is-active'); });
    chip.classList.add('is-active');
    var f = chip.dataset.mkGalFilter;
    qa('[data-mk-gal-grid="' + target + '"] [data-mk-gal-item]').forEach(function (el) {
      el.style.display = (f === 'alle' || el.dataset.mkGalItem === f) ? '' : 'none';
    });
  });

  /* ================= Kategorie-Reiter ================= */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-mk-tab-chip]');
    if (!chip) return;
    var target = chip.dataset.mkTabChip;
    qa('[data-mk-tab-chip="' + target + '"]').forEach(function (c) { c.classList.remove('is-active'); });
    chip.classList.add('is-active');
    var key = chip.dataset.mkTab;
    qa('[data-mk-tab-panel="' + target + '"]').forEach(function (p) { p.style.display = p.dataset.mkTab === key ? '' : 'none'; });
  });

  /* ================= Betrags-Chips (Gutschein-Formular) ================= */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-mk-amount]');
    if (!chip) return;
    e.preventDefault();
    var wrap = chip.closest('[data-mk-amount-group]');
    if (!wrap) return;
    qa('[data-mk-amount]', wrap).forEach(function (c) { c.classList.remove('is-active'); });
    chip.classList.add('is-active');
    var field = q('[data-mk-amount-field]', wrap.closest('form') || document);
    if (field) field.value = chip.dataset.mkAmount;
  });

  /* ================= Zwei-Klick-Karte ================= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mk-map-load]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.mk-map');
    if (!wrap) return;
    var src = wrap.dataset.mkMapSrc;
    var consent = q('.mk-map__consent', wrap);
    var frame = document.createElement('iframe');
    frame.src = src;
    frame.title = 'Karte';
    frame.loading = 'lazy';
    frame.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    wrap.appendChild(frame);
    if (consent) consent.remove();
  });

  if (!shopEnabled) {
    if (document.readyState !== 'loading') initMotion(); else document.addEventListener('DOMContentLoaded', initMotion);
    ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:select', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        qa('.mk-reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
        initMotion();
      });
    });
    return;
  }

  /* ================= Drawer ================= */
  var root, drawer, overlay;
  function openDrawer() { if (!drawer) return; drawer.hidden = false; overlay.hidden = false; document.documentElement.style.overflow = 'hidden'; requestAnimationFrame(function () { root.classList.add('is-open'); }); }
  function closeDrawer() { if (!drawer) return; root.classList.remove('is-open'); document.documentElement.style.overflow = ''; setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 260); }
  function fetchCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function render(cart) {
    qa('[data-mk-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    qa('[data-mk-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.items_subtotal_price, moneyFormat); });
    var wrap = q('[data-mk-cart-items]');
    if (wrap) {
      if (!cart.items.length) {
        wrap.innerHTML = '<div class="mk-cart-empty"><p>Ihr Warenkorb ist leer.</p><a class="mk-btn mk-btn--sm" href="' + (cfg.shopUrl || '/') + '">Zur Pflege-Linie</a></div>';
      } else {
        wrap.innerHTML = cart.items.map(function (item, i) {
          var img = item.image ? '<img src="' + item.image + '&width=180" alt="" loading="lazy" onerror="this.style.display=\'none\'">' : '';
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="mk-cart-item__variant">' + esc(item.variant_title) + '</div>' : '';
          var url = item.url || '#';
          return '<div class="mk-cart-item" data-line="' + (i + 1) + '">' +
            '<a class="mk-cart-item__img" href="' + url + '">' + img + '</a>' +
            '<div class="mk-cart-item__body">' +
              '<a class="mk-cart-item__title" href="' + url + '">' + esc(item.product_title) + '</a>' + variant +
              '<div class="mk-cart-item__row">' +
                '<div class="mk-cart-qty"><button type="button" data-mk-qty="-1" aria-label="Weniger">−</button><span>' + item.quantity + '</span><button type="button" data-mk-qty="1" aria-label="Mehr">+</button></div>' +
                '<span class="mk-cart-item__price">' + formatMoney(item.final_line_price, moneyFormat) + '</span>' +
              '</div>' +
              '<button type="button" class="mk-cart-item__remove" data-mk-remove>Entfernen</button>' +
            '</div></div>';
        }).join('');
      }
    }
    loadCrossSell(cart);
  }
  function change(line, quantity) {
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
      .then(function (r) { return r.json(); }).then(render);
  }
  function refresh() { return fetchCart().then(render); }
  function addVariant(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: qty || 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(refresh).then(openDrawer);
  }

  /* ---------- Cross-Selling ---------- */
  function loadCrossSell(cart) {
    var box = q('[data-mk-crosssell]'); if (!box) return;
    var items = q('[data-mk-crosssell-items]');
    if (!cart.items.length) { box.hidden = true; return; }
    var inCart = cart.items.map(function (i) { return i.product_id; });
    if (box.dataset.mkManual) {
      var any = false;
      qa('[data-mk-cross-pid]', box).forEach(function (el) {
        var hide = inCart.indexOf(parseInt(el.dataset.mkCrossPid, 10)) !== -1;
        el.style.display = hide ? 'none' : '';
        if (!hide) any = true;
      });
      box.hidden = !any;
      return;
    }
    fetch('/recommendations/products.js?product_id=' + cart.items[0].product_id + '&limit=6&intent=complementary', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var prods = (data.products || []).filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available; });
        if (!prods.length) { box.hidden = true; return; }
        items.innerHTML = prods.slice(0, 2).map(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy">' : '';
          var vid = p.variants && p.variants.length ? p.variants[0].id : '';
          return '<div class="mk-cross-item">' +
            '<a class="mk-cross-item__img" href="' + p.url + '">' + img + '</a>' +
            '<a class="mk-cross-item__body" href="' + p.url + '"><div class="mk-cross-item__title">' + esc(p.title) + '</div>' +
            '<div class="mk-cross-item__price">' + formatMoney(p.price, moneyFormat) + '</div></a>' +
            '<button type="button" class="mk-cross-item__add" data-mk-quickadd="' + vid + '" aria-label="Hinzufügen" title="Hinzufügen">+</button></div>';
        }).join('');
        box.hidden = false;
      }).catch(function () { box.hidden = true; });
  }

  /* ---------- Quick View ---------- */
  function openQuickView(handle) {
    var rootQv = q('#mk-qv-root'); if (!rootQv) return;
    var body = q('[data-mk-qv-body]');
    body.innerHTML = '<div class="mk-qv-loading">Wird geladen …</div>';
    rootQv.hidden = false;
    requestAnimationFrame(function () { rootQv.classList.add('is-open'); });
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); })
      .then(function (p) {
        var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="' + esc(p.title) + '">' : '';
        var desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        if (desc.length > 220) desc = desc.slice(0, 220) + ' …';
        var compare = p.compare_at_price && p.compare_at_price > p.price ? ' <s style="font-size:15px;color:#8A8F9C;">' + formatMoney(p.compare_at_price, moneyFormat) + '</s>' : '';
        var options = p.variants.map(function (v) {
          return '<option value="' + v.id + '" data-price="' + v.price + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' — ausverkauft') + '</option>';
        }).join('');
        var variantSel = p.variants.length > 1
          ? '<select class="mk-select" name="id" style="margin-bottom:14px;">' + options + '</select>'
          : '<input type="hidden" name="id" value="' + p.variants[0].id + '">';
        body.innerHTML = '<div class="mk-qv-grid">' +
          '<div class="mk-qv-media">' + img + '</div>' +
          '<div class="mk-qv-info">' +
            '<div class="mk-qv-type">' + esc(p.type || 'Mystic Pflege') + '</div>' +
            '<div class="mk-qv-title">' + esc(p.title) + '</div>' +
            '<div class="mk-qv-price"><span data-mk-qv-price>' + formatMoney(p.price, moneyFormat) + '</span>' + compare + '</div>' +
            '<p class="mk-qv-desc">' + esc(desc) + '</p>' +
            '<form action="/cart/add" method="post" class="mk-qv-form">' + variantSel +
              '<button type="submit" class="mk-btn" style="display:block;width:100%;"' + (p.available ? '' : ' disabled') + '>' + (p.available ? 'In den Warenkorb' : 'Ausverkauft') + '</button>' +
            '</form>' +
          '</div></div>';
      })
      .catch(function () { body.innerHTML = '<div class="mk-qv-loading">Produkt konnte nicht geladen werden.</div>'; });
  }
  function closeQuickView() { var r = q('#mk-qv-root'); if (!r || r.hidden) return; r.classList.remove('is-open'); setTimeout(function () { r.hidden = true; }, 220); }

  /* ---------- Events ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.mkLabel = btn.textContent; btn.textContent = 'Wird hinzugefügt …'; }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { closeQuickView(); openDrawer(); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.mkLabel; } });
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mk-cart-open]')) { e.preventDefault(); refresh().then(openDrawer); return; }
    if (t.closest('[data-mk-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    var qv = t.closest('[data-mk-quickview]');
    if (qv) { e.preventDefault(); openQuickView(qv.dataset.mkQuickview); return; }
    if (t.closest('[data-mk-qv-close]')) { e.preventDefault(); closeQuickView(); return; }
    var quick = t.closest('[data-mk-quickadd]');
    if (quick) {
      e.preventDefault();
      if (!quick.dataset.mkQuickadd) return;
      quick.disabled = true;
      addVariant(quick.dataset.mkQuickadd).catch(function () { window.location.href = '/cart'; }).finally(function () { quick.disabled = false; });
      return;
    }
    var qty = t.closest('[data-mk-qty]');
    if (qty) {
      var item = qty.closest('.mk-cart-item');
      var line = parseInt(item.dataset.line, 10);
      var current = parseInt(item.querySelector('.mk-cart-qty span').textContent, 10);
      change(line, Math.max(0, current + parseInt(qty.dataset.mkQty, 10)));
      return;
    }
    var rm = t.closest('[data-mk-remove]');
    if (rm) { change(parseInt(rm.closest('.mk-cart-item').dataset.line, 10), 0); }
  });
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches('.mk-qv-form select[name="id"]')) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = q('[data-mk-qv-price]');
    if (priceEl && opt && opt.dataset.price) priceEl.textContent = formatMoney(parseInt(opt.dataset.price, 10), moneyFormat);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeQuickView(); closeDrawer(); } });
  function boot() {
    root = q('#mk-cart-root'); drawer = q('.mk-cart-drawer'); overlay = q('.mk-cart-overlay');
    initMotion();
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:select', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      qa('.mk-reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
      initMotion();
    });
  });
})();